import {TFunction} from 'i18next';
import {object, SchemaOf, string} from 'yup';
import {Merchant} from '../../../shared/model/Merchant.model';
import {Shop} from '../../../shared/model/Shop.model';

export interface ShopFormFields extends Omit<Shop, 'platform'> {
  platform: string;
}

export const shopFormInitialValues = (merchant: Merchant): ShopFormFields => ({
  name: merchant?.name ?? '',
  platform: merchant?.platform ?? '',
  websiteUrl: merchant?.websiteUrl ?? ''
});

export const shopFormValidationSchema = (t: TFunction): SchemaOf<ShopFormFields> =>
  object({
    name: string().defined(t('SHARED.ERROR.FIELD_REQUIRED')),
    platform: string().defined(t('SHARED.ERROR.FIELD_REQUIRED')),
    websiteUrl: string().defined(t('SHARED.ERROR.FIELD_REQUIRED'))
  }).defined();